<template>
  <v-layout
    v-if="selectedTimeframes.length > 0"
    justify-end
    align-center
  >
    <transition-group name="timeframes-list-transition">
      <v-chip
        v-for="timeframe of selectedTimeframes"
        :key="timeframe.id"
        small
        close
        color="msr"
        outline
        @input="removeSelectedTimeframe(timeframe)"
      >
        <v-avatar>
          <v-icon>timelapse</v-icon>
        </v-avatar>
        <span v-if="timeframe.name">
          {{ timeframe.name }}
        </span>
        <span v-else>
          {{ describeWeekdays(timeframe.weekdays) }}: {{ timeframe.start }} -
          {{ timeframe.end }}
        </span>
      </v-chip>
    </transition-group>
  </v-layout>
</template>

<script>
import {describeWeekdays} from '@/mixins/weekdays';
import selectedTimeframes from '@/mixins/selectedTimeframes.js';

export default {
  mixins: [selectedTimeframes],
  methods: {
    describeWeekdays: describeWeekdays,
  },
};
</script>

<style scoped>
.timeframes-list-transition-enter-active,
.timeframes-list-transition-leave-active {
  transition: all 0.25s ease-in-out;
}
.timeframes-list-transition-enter,
.timeframes-list-transition-leave-to {
  opacity: 0;
  transform: translateY(-50px);
}
</style>



// WEBPACK FOOTER //
// src/components/SelectedTimeframeChip.vue